<template>
  <div>
    <b-btn v-b-modal.modalAcceptance
           variant="info"
           v-text="buttonText.toUpperCase()"/>

    <modal-acceptance :modal-title="modalTitleText"
                      :ok-button-text="buttonText"
                      ok-button-variant="info"
                      @ok="submitAll"/>
  </div>
</template>

<script>
  import ModalAcceptance from '@/components/ModalAcceptance';
  import { infrastructureMixin } from '@/mixins/infrastructure';

  export default {
    name: 'ActionSubmitAllButton',
    components: { ModalAcceptance },
    mixins: [infrastructureMixin],
    props: {
      config: {
        type: Object,
        required: true,
        validator(value) {
          const requiredFields = ['modalTitleText', 'buttonText', 'path'];
          const configKeys = Object.keys(value);
          return requiredFields.every((field) => configKeys.includes(field));
        },
      },
      selectedCall: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        modalTitleText: `Are you sure you want to confirm submission of all
        ${this.config.modalTitleText} connected to selected call?`,
        buttonText: `Submit all ${this.config.buttonText}`,
      };
    },
    methods: {
      async submitAll() {
        const callData = { call: this.selectedCall };
        try {
          const response = await this.axios.patch(`/documents/${this.config.path}/${this.infrastructure}`, callData);
          this.$notify({ type: 'success', title: response.data.message });
        } catch (error) {
          if (error.response.data.error) {
            this.$notify({ type: 'error', title: error.response.data.error, duration: 7000 });
          } else {
            this.$notify({ type: 'error', title: 'Communication error', duration: 7000 });
          }
        }
        this.$emit('reload-proposals');
      },
    },
  };
</script>

<style scoped>

</style>
